const THEME_MODE_STORAGE_KEY = 'itmart24-theme-mode';
const THEME_MODE_ATTRIBUTE = 'data-theme';
const THEME_MODE_DARK = 'dark';
const THEME_MODE_LIGHT = 'light';

function getStoredThemeMode() {
  try {
    return window.localStorage.getItem(THEME_MODE_STORAGE_KEY);
  } catch (error) {
    return null;
  }
}

function getResolvedThemeMode() {
  const storedMode = getStoredThemeMode();

  if (storedMode === THEME_MODE_DARK || storedMode === THEME_MODE_LIGHT) {
    return storedMode;
  }

  return THEME_MODE_DARK;
}

function setDocumentThemeMode(mode) {
  const root = document.documentElement;

  root.setAttribute(THEME_MODE_ATTRIBUTE, mode);
  root.style.colorScheme = mode;
}

function updateThemeColorMeta() {
  const themeColorMeta = document.querySelector('meta[name="theme-color"]');
  const backgroundTarget = document.body || document.documentElement;

  if (!themeColorMeta || !backgroundTarget) return;

  const backgroundColor = window.getComputedStyle(backgroundTarget).backgroundColor;

  if (backgroundColor) {
    themeColorMeta.setAttribute('content', backgroundColor);
  }
}

function updateThemeModeButtons(mode = getResolvedThemeMode()) {
  const nextMode = mode === THEME_MODE_DARK ? THEME_MODE_LIGHT : THEME_MODE_DARK;
  const label = `Switch to ${nextMode} mode`;

  document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
    button.setAttribute('aria-pressed', String(mode === THEME_MODE_DARK));
    button.setAttribute('aria-label', label);
    button.dataset.theme = mode;

    const labelNode = button.querySelector('[data-theme-toggle-label]');

    if (labelNode) {
      labelNode.textContent = label;
    }
  });
}

function applyThemeMode(mode, options = {}) {
  const persist = options.persist !== false;

  setDocumentThemeMode(mode);

  if (persist) {
    try {
      window.localStorage.setItem(THEME_MODE_STORAGE_KEY, mode);
    } catch (error) {}
  }

  updateThemeModeButtons(mode);
  updateThemeColorMeta();

  document.dispatchEvent(
    new CustomEvent('theme:change', {
      detail: { mode },
    })
  );
}

function handleThemeToggleClick(event) {
  const toggleButton = event.target.closest('[data-theme-toggle]');

  if (!toggleButton) return;

  event.preventDefault();

  const nextMode = getResolvedThemeMode() === THEME_MODE_DARK ? THEME_MODE_LIGHT : THEME_MODE_DARK;
  applyThemeMode(nextMode);
}

function syncThemeModeWithSystem(event) {
  return;
}

function initializeThemeMode() {
  const initialMode = getResolvedThemeMode();

  setDocumentThemeMode(initialMode);
  updateThemeModeButtons(initialMode);
  updateThemeColorMeta();
}

document.addEventListener('click', handleThemeToggleClick);
document.addEventListener('DOMContentLoaded', initializeThemeMode);
document.addEventListener('shopify:section:load', initializeThemeMode);

if (typeof window.matchMedia === 'function') {
  const themeModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

  if (typeof themeModeMediaQuery.addEventListener === 'function') {
    themeModeMediaQuery.addEventListener('change', syncThemeModeWithSystem);
  } else if (typeof themeModeMediaQuery.addListener === 'function') {
    themeModeMediaQuery.addListener(syncThemeModeWithSystem);
  }
}

window.ThemeMode = {
  get: getResolvedThemeMode,
  set(mode) {
    if (mode !== THEME_MODE_DARK && mode !== THEME_MODE_LIGHT) return;

    applyThemeMode(mode);
  },
};
